module.exports = __webpack_public_path__ + "static/media/diagnostic.159e9f26.svg";